export default __webpack_public_path__ + "static/media/base.f5cf74c2.png";